module.exports = __webpack_public_path__ + "15685d728330f7784d80d01de6df5d84.png";